import { render } from "./CalendarEventSession.vue?vue&type=template&id=2dbfa7be&scoped=true"
import script from "./CalendarEventSession.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./CalendarEventSession.vue?vue&type=script&charset=utf-8&lang=js"

import "./CalendarEventSession.vue?vue&type=style&index=0&id=2dbfa7be&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dbfa7be"]])

export default __exports__